/* eslint-disable react/prop-types */
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { Container, VariationsList, Variation } from './styles';
import { getProductImage } from '../../../helpers';
import notAvailable from '../../../assets/images/picture-not-available.jpg';

const VariationSelector = ({ product }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const productImage = getProductImage(product);

  const getVariationImage = (variation) =>
    variation?.image?.formats.thumbnail.url;

  const selectVariation = ({ sku }) => {
    setSearchParams({ sku });
  };

  const isActive = ({ sku }) => {
    const skuParam = searchParams.get('sku');
    return sku === skuParam;
  };

  return (
    <>
      {product.variations.length > 1 && (
        <Container>
          {/* <b>Variations:</b> */}
          <VariationsList>
            {product.variations.map((vari) => (
              <Variation
                key={vari.id}
                onClick={() => selectVariation(vari)}
                className={isActive(vari) && `active`}
              >
                <img
                  src={`${
                    getVariationImage(vari) || productImage || notAvailable
                  }`}
                  alt=""
                />
                <p>{vari.sku}</p>
              </Variation>
            ))}
          </VariationsList>
        </Container>
      )}
    </>
  );
};

export default VariationSelector;
